/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weary_Spare_Elephant_LoopInputs */

const fr_weary_spare_elephant_loop = /** @type {(inputs: Weary_Spare_Elephant_LoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

/**

* @param {Weary_Spare_Elephant_LoopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weary_spare_elephant_loop = /** @type {((inputs?: Weary_Spare_Elephant_LoopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weary_Spare_Elephant_LoopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weary_spare_elephant_loop(inputs)
});